export default __webpack_public_path__ + "static/media/lib-5.ba57ab29.webp";